//import firebase from 'firebase/app';
//import 'firebase/auth';
import parentAuthService from '@/app-template/lib/services/AuthService';

export default {
  ...parentAuthService,
}